import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { setSuccess } from './classesReducer';

type ZoomResultsList = {
    id: number;
    email: string;
    zoom_id: string;
    type: number;
    zoom_status: string | null;
    zoom_type: string;
};
type ZoomSubAccountsList = {
    count:number,
    results:ZoomResultsList[]
}
type ZoomState = {
    zoomMasterList: ZoomResultsList[];
    zoomSubAccountsList:ZoomSubAccountsList
    count: number;  ///count of the zoom master list
    loading: boolean;
    successCreation: boolean;
    successSynchronization:boolean;
    successSubAccountCreation:boolean;
    errorType: string;
    loadingCreation: boolean;
    successRemoveZoomProAccount: boolean;
    successRemoveZoomSubAccount: boolean;
    successAssignForUser: boolean;
};
const initialState: ZoomState = {
    zoomMasterList: [],
    zoomSubAccountsList: {
        count: 0,
        results: [],
    },
    loading: false,
    successCreation: false,
    successSynchronization:false,
    successSubAccountCreation:false,
    count: 0,
    errorType: '',
    loadingCreation: false,
    successRemoveZoomProAccount: false,
    successRemoveZoomSubAccount: false,
    successAssignForUser: false,
}
const zoomSlice = createSlice({
    name: 'zoom',
    initialState,
    reducers: {
        setLoading(state, action) {
            state.loading = action.payload;
        },
        setZoomMasterList(state, action) {
            state.zoomMasterList = action.payload;
        },
        setZoomSubAccountsList(state, action) {
            state.zoomSubAccountsList = action.payload;
        },
        setSuccessCreation(state, action) {
            state.successCreation = action.payload;
        },
        setSuccessSynchronization(state, action) {
            state.successSynchronization = action.payload;
        },
        setSuccessSubAccountCreation(state, action) {
            state.successSubAccountCreation = action.payload;
        },
        setCount(state, action) {
            state.count = action.payload;
        },
        setErrorType(state, action) {
            state.errorType = action.payload;
        },
        setLoadingCreation(state, action) {
            state.loadingCreation = action.payload;
        },
        setSuccessRemoveZoomProAccount(state, action) {
            state.successRemoveZoomProAccount = action.payload;
        },
        setSuccessRemoveZoomSubAccount(state, action) {
            state.successRemoveZoomSubAccount = action.payload;
        },
        setSuccessAssignForUser(state, action) {
            state.successAssignForUser = action.payload;
        },
    },
});

export const {
    setLoading,
    setZoomMasterList,
    setZoomSubAccountsList,
    setSuccessCreation,
    setSuccessSynchronization,
    setSuccessSubAccountCreation,
    setCount,
    setErrorType,
    setLoadingCreation,
    setSuccessRemoveZoomProAccount,
    setSuccessRemoveZoomSubAccount,
    setSuccessAssignForUser
} = zoomSlice.actions;

export default zoomSlice.reducer;